import { render, staticRenderFns } from "./detailed_metric.vue?vue&type=template&id=933e9d1a"
import script from "./detailed_metric.vue?vue&type=script&lang=js"
export * from "./detailed_metric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports